import { render, staticRenderFns } from "./BoxChart.vue?vue&type=template&id=d3b24426"
import script from "./BoxChart.vue?vue&type=script&lang=js"
export * from "./BoxChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports